/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import MultiSelectInputMUI from '@brands/Components/Inputs/MuiMultiSelectInput/MultiSelectInputMUI';
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import PhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import ProfileImage from '@brands/Components/ProfileImage/ProfileImage';
import { useInsuranceCarriers } from '@brands/hooks';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { validateAddress, ValidationModalInterface } from '@brands/Utils/validateAddress';
import { yupResolver } from '@hookform/resolvers/yup';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Box,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import cn from 'classnames';
import { E164Number, parsePhoneNumber } from 'libphonenumber-js';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useForm, UseFormGetValues } from 'react-hook-form';
import { toast } from 'react-toastify';

import Button from '../../../../../Components/Button/Button';
import { RegisterMediaPayload } from '../../../../../services/communication/registersConversationMedia';
import { confirmAvatarMedia } from '../../../../../services/identity/confirmAvatarMedia';
import { createBasicInformation } from '../../../../../services/identity/createBasicInformation';
import { createNewUser, fullNameFromFirstAndLast } from '../../../../../services/identity/createNewUser';
import { createPatientInsurance } from '../../../../../services/identity/createPatientInsurance';
import { deleteAvatar } from '../../../../../services/identity/deleteAvatar';
import { listAllClientTags } from '../../../../../services/identity/listAllClientTags';
import {
  forcedActorClientTagId,
  scopeClientTagOptionsToActor,
} from '../../../../../services/identity/clientTagActorScope';
import { listAllLanguages } from '../../../../../services/identity/listAllLanguages';
import { registerAvatarMedia } from '../../../../../services/identity/registerAvatarMedia';
import { confirmOneReportMedia } from '@brands/services/oneReport/confirmOneReportMedia';
import { registerOneReportMedia } from '@brands/services/oneReport/registerOneReportMedia';
import { base64ListToFileList } from '@brands/Utils/base64ToFile';
import { getFileMimeType } from '@brands/Utils/truncateString';
import {
  Address,
  BasicInfo,
  ClientTag,
  Insurance,
  Language,
  UserProfile,
  UserRoleName,
} from '../../../../../services/identity/types/UserProfile';
import { getClientDivisionOptions } from '../../../../../services/identity/clientDivisionOptions';
import { updateUserClientTag } from '../../../../../services/identity/updateUserClientTag';
import { checkAndSetDate } from '../../../../../Utils/checkAndSetDate';
import { multiSelectCommonCustomStylesLarge, selectCommonCustomStylesLarge } from '../../../../../Utils/customStyles';
import { displayErrorDetails } from '../../../../../Utils/displayError';
import { genderIdentity, genderOptions, pronounsOptions } from '../../../../../Utils/selectButtonOptions';
import { OptionLanguage, stateOptions } from '../../../../../Utils/selectOptions';
import { defaultFormValues } from '../../../../MyProfile/Patient/utils/defaultFormValues';
import { MyProfileSubmit } from '../../../../MyProfile/Patient/utils/types';
import {
  updateData,
  updateDataInsuranceNewDesign,
  updateDataSecondaryInsuranceNewDesign,
  UploadedFile,
} from '../../../../MyProfile/Patient/utils/utilsFunctions';
import AddressSection from '../../Components/AddressSection/AddressSection';
import styles from '../styles.module.scss';
import addNewUserStyles from '../../../Collector/AddNewUser/addNewUser.module.scss';
import { validationSchema } from './validationSchema';
import { dateAutoSlashes } from '@brands/Utils/checkAndSetDate';

import { defaultInsuranceForm } from '@brands/Dashboard/Insurance/utils/types.ts';
import { validationSchemaNewDesign } from '@brands/Dashboard/Insurance/utils/validationSchema.ts';
import InsuranceFormSection from '@brands/Dashboard/Insurance/InsuranceFormSection.tsx';

import { heicTo } from 'heic-to';

type FormValues = MyProfileSubmit & typeof defaultInsuranceForm;

const primaryInsuranceErrorOrder = [
  'insurance_carrier_id',

  'member_id',

  'insurance_phone_number',

  'insurance_address',

  'insurance_city',

  'insurance_state',

  'insurance_zip_code',

  'insurance_through',

  'insurance_first_name',

  'insurance_last_name',

  'insurance_date_of_birth',

  'insurance_gender',

  'insurance_address1',

  'insurance_city1',

  'insurance_state1',

  'insurance_zip_code1',

  'state_funded_coverage_status',
];

const secondaryInsuranceErrorOrder = [
  'secondary_insurance_carrier_id',

  'secondary_member_id',

  'secondary_insurance_phone_number',

  'secondary_insurance_address',

  'secondary_insurance_city',

  'secondary_insurance_state',

  'secondary_insurance_zip_code',

  'secondary_insurance_through',

  'secondary_insurance_first_name',

  'secondary_insurance_last_name',

  'secondary_insurance_date_of_birth',

  'secondary_insurance_gender',

  'secondary_insurance_address1',

  'secondary_insurance_city1',

  'secondary_insurance_state1',

  'secondary_insurance_zip_code1',
];

const getFirstErrorMessageByDisplayOrder = (errorsList: Record<string, { message?: string }>): string | undefined => {
  const displayOrder = [
    'first_name',

    'middle_name',

    'last_name',

    'preferred_name',

    'date_of_birth',

    'gender',

    'gender_identity',

    'pronouns',

    'language',

    'phone_number',

    'address1',

    'city',

    'state',

    'zip_code',

    'email',

    'clientTag',

    ...primaryInsuranceErrorOrder,

    ...secondaryInsuranceErrorOrder,
  ];

  const firstOrderedErrorKey = displayOrder.find((key) => errorsList[key]?.message);

  return firstOrderedErrorKey ? errorsList[firstOrderedErrorKey]?.message : Object.values(errorsList)[0]?.message;
};

interface ProfileCardProps {
  onClose: () => void;
}

// No acting role picks an organization (or organization division/practice) when creating a
// patient; every patient belongs to Dentistry.One, which is also what gates the Client tags section.
const DENTISTRY_ONE_ORGANIZATION_OPTION = { id: 'dentistry-one', value: 'dentistry-one', label: 'Dentistry One' };

const AddPatientUserPage: FC<ProfileCardProps> = ({ onClose }) => {
  const { userInfo } = useAppSelector(selectAuth);
  const [myProfileForm, setMyProfileForm] = useState<MyProfileSubmit>(defaultFormValues as MyProfileSubmit);
  const [currentAvatarURL, setCurrentAvatarURL] = useState<string>('');
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [avatarPayload, setAvatarPayload] = useState<RegisterMediaPayload | null>(null);
  const [selection, setSelection] = React.useState<[number | null, number | null] | null>(null);
  const ref = React.useRef<HTMLInputElement>(null);
  const [validationResponseId, setValidationResponseId] = useState('');
  const [languageOptions, setLanguageOptions] = useState<OptionLanguage[]>([]);
  const [avatarAction, setAvatarAction] = useState<string>('');
  const [image, setImage] = React.useState<string>();
  const [email, setEmail] = useState('');
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [isSendingInvitation, setIsSendingInvitation] = useState(false);
  const [addPrimaryInsurance, setAddPrimaryInsurance] = useState(false);
  const [addSecondaryInsurance, setAddSecondaryInsurance] = useState(false);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [images, setImages] = useState({
    front_of_card: [],
    back_of_card: [],
    secondary_front_of_card: [],
    secondary_back_of_card: [],
  } as any);
  const [clientTagOptions, setClientTagOptions] = useState<{ id: string; value: string; label: string }[]>([]);
  const [allClientTags, setAllClientTags] = useState<ClientTag[]>([]);

  const [showValidationAddressModal, setShowValidationAddressModal] = useState<ValidationModalInterface>({
    isOpen: false,
    title: '',
    whatYouEntered: '',
    recommended: false,
    recommendedAddress: '',
    onClose: undefined,
    onConfirmChange: undefined,
    onKeepCurrentAddress: undefined,
  });
  const insuranceCarriers = useInsuranceCarriers();
  const insuranceCarrierOptions = useMemo(() => {
    return insuranceCarriers.map((insuranceCarrier) => ({
      value: insuranceCarrier.id,
      label: insuranceCarrier.name,
    }));
  }, [insuranceCarriers]);
  const closePage = (): void => {
    onClose();
  };

  const isQuickAdd: boolean = useMemo((): boolean => {
    return !isSendingInvitation && email === '';
  }, [isSendingInvitation, email]);
  // Required for every role once the field is actually on the page (mirrors the
  // `clientTagOptions.length > 0` visibility check on the Client tag select below) --
  // requiredness used to be gated to CareAdvisor/Collector/OrganizationAdmin only.
  const clientTagsRequired = useMemo(() => clientTagOptions.length > 0, [clientTagOptions]);
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
    getValues,
    watch,
  } = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: defaultInsuranceForm as Partial<FormValues>,
    resolver: async (values, context, options) => {
      const normalizedValues = { ...values };
      if (!addPrimaryInsurance) {
        normalizedValues.insurance_carrier_id = undefined;
      }
      if (!addSecondaryInsurance) {
        normalizedValues.secondary_insurance_carrier_id = undefined;
      }
      const computedIsQuickAdd = !isSendingInvitation && !String(normalizedValues.email || '').trim();

      return yupResolver(
        validationSchema(addSecondaryInsurance, computedIsQuickAdd, false, clientTagsRequired, isSendingInvitation),
      )(normalizedValues, context, options);
    },
  });

  const watchedClientTag = watch('clientTag');
  const divisionOptions = useMemo(
    () =>
      getClientDivisionOptions(
        allClientTags,
        (watchedClientTag || []).map((tag) => tag.value),
      ).map((option) => ({
        id: option.id,
        value: String(option.value),
        label: option.label,
      })),
    [allClientTags, watchedClientTag],
  );

  const triggerProfileAvatar = React.useCallback((avatarUrl: string) => {
    setValue('profile_img', avatarUrl, { shouldValidate: true });
    setMyProfileForm({
      ...getValues(),
      profile_img: avatarUrl,
    });
  }, []);
  const onCloseConfirmationModal = (): void => {
    setShowValidationAddressModal({
      isOpen: false,
      title: '',
      whatYouEntered: '',
      recommended: false,
      recommendedAddress: '',
      onClose: undefined,
      onConfirmChange: undefined,
      onKeepCurrentAddress: undefined,
    });
  };

  const fetchLanguageOptions = async (): Promise<void> => {
    try {
      const data = await listAllLanguages();
      const transformedData = data.map((language) => ({
        value: language.locale,
        label: language.name,
        id: language.id,
      }));
      setLanguageOptions(transformedData);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    fetchLanguageOptions();
    setValue('organization', [DENTISTRY_ONE_ORGANIZATION_OPTION], { shouldValidate: true });
    setMyProfileForm((prev) => ({ ...prev, organization: [DENTISTRY_ONE_ORGANIZATION_OPTION] }));
    listAllClientTags()
      .then(({ nodes }) => {
        const mapped = (nodes || []).map((c) => ({ id: String(c.id), value: String(c.id), label: c.name }));
        const scopedOptions = scopeClientTagOptionsToActor(mapped, userInfo);
        setClientTagOptions(scopedOptions);
        setAllClientTags(nodes || []);

        // A Client Admin scoped to exactly one client tag has their new
        // patients inherit it automatically on the backend regardless of
        // what this form submits, so pre-select it here too rather than
        // leaving the only valid option empty.
        const forcedTagId = forcedActorClientTagId(userInfo);
        if (forcedTagId) {
          const forcedOption = scopedOptions.find((option) => option.value === forcedTagId);
          if (forcedOption) {
            setValue('clientTag', [forcedOption], { shouldValidate: true });
          }
        }
      })
      .catch(displayErrorDetails);
  }, []);

  const setTextValue = (e: React.ChangeEvent<HTMLInputElement>, name: string): void => {
    const { value } = e.target;
    setValue(name as keyof MyProfileSubmit, value, { shouldValidate: true });
    setSelection([e.target.selectionStart, e.target.selectionEnd]);
  };

  React.useLayoutEffect(() => {
    if (selection && ref.current) {
      [ref.current.selectionStart, ref.current.selectionEnd] = selection;
    }
  }, [selection]);

  const onInvalid = (errorsList: Record<string, { message?: string }>): void => {
    const message = getFirstErrorMessageByDisplayOrder(errorsList);

    if (message) {
      toast.error(message);
    }
  };

  const onCancelEditProfile = (): void => {
    onClose();
    setImage(currentAvatarURL);
  };

  const callSaveProfile = async (profileData: UnifiedProfileSubmit): Promise<void> => {
    const typedProfile = profileData as MyProfileSubmit;
    setIsSavingProfile(true);
    let newUser: UserProfile | undefined;

    const fullNameForCreateUser = fullNameFromFirstAndLast(profileData.first_name, profileData.last_name);
    const selectedClientTag = getValues('clientTag')?.[0];
    const isDentistryOne = (typedProfile.organization || []).some((org) => org.id === 'dentistry-one');

    try {
      newUser = await createNewUser({
        email: profileData.email?.toLowerCase(),
        ...(selectedClientTag?.id && isDentistryOne && { client_ids: [Number(selectedClientTag.id)] }),
        ...(typedProfile.external_id?.trim() &&
          selectedClientTag?.id &&
          isDentistryOne && { external_id: typedProfile.external_id.trim() }),
        ...(typedProfile.phone_number && {
          phone_number: parsePhoneNumber(typedProfile.phone_number, 'US')?.format('E.164') as string,
        }),
        ...(profileData.address1 !== '' ||
        profileData.address2 !== '' ||
        profileData.city !== '' ||
        profileData.state !== '' ||
        profileData.zip_code !== ''
          ? {
              address: {
                ...(profileData.address1 !== '' && { address1: profileData.address1 }),
                ...(profileData.address2 !== '' && { address2: profileData.address2 }),
                ...(profileData.city !== '' && { city: profileData.city }),
                ...(profileData.state !== '' && { state: profileData.state }),
                ...(profileData.zip_code !== '' && { zip_code: profileData.zip_code }),
              } as Address,
            }
          : {}),
        type: UserRoleName.Patient,
        organization_ids: [DENTISTRY_ONE_ORGANIZATION_OPTION.id],
        send_invitation: isSendingInvitation,
        ...(fullNameForCreateUser ? { full_name: fullNameForCreateUser } : {}),
        // With no organization division/practice to pick there is no branded domain to
        // invite from, so invite from the site the creating user is on.
        frontend_website: window.location.origin,
        is_quick_add: isQuickAdd,
      });
    } catch (error: unknown) {
      displayErrorDetails(error);
      setIsSavingProfile(false);
    }
    if (newUser) {
      try {
        const selectedClientDivision = getValues('clientDivision')?.[0];
        if (selectedClientDivision?.id && selectedClientTag?.id && isDentistryOne) {
          await updateUserClientTag(newUser.id, {
            client_ids: [Number(selectedClientTag.id)],
            client_division_ids: [Number(selectedClientDivision.id)],
          });
        }
        if (avatarPayload && avatarFile && avatarAction === 'Upload') {
          const res = await registerAvatarMedia(avatarPayload);
          const mediaId = res.files[0].upload_id;
          await fetch(res.files[0].upload_url, {
            method: 'PUT',
            body: avatarFile,
            headers: { 'content-type': avatarFile.type },
          });
          await confirmAvatarMedia(mediaId, newUser.id);
          triggerProfileAvatar(res.files[0].upload_url);
        } else if (avatarAction === 'Remove') {
          await deleteAvatar(newUser.id);
          triggerProfileAvatar('');
        }

        const dataWithUpdatedDOB = updateData(typedProfile as BasicInfo);
        if (
          dataWithUpdatedDOB.first_name !== '' ||
          dataWithUpdatedDOB.middle_name !== '' ||
          dataWithUpdatedDOB.last_name !== '' ||
          dataWithUpdatedDOB.gender !== '' ||
          dataWithUpdatedDOB.date_of_birth !== 'Invalid date' ||
          dataWithUpdatedDOB.pronouns !== '' ||
          (Array.isArray(dataWithUpdatedDOB.languages) &&
            dataWithUpdatedDOB.languages.length > 0 &&
            (dataWithUpdatedDOB.languages[0] as Language).name !== '')
        ) {
          const basicInfoPayload: Record<string, unknown> = {
            first_name: dataWithUpdatedDOB.first_name ?? '',
            ...(dataWithUpdatedDOB.middle_name && { middle_name: dataWithUpdatedDOB.middle_name }),
            last_name: dataWithUpdatedDOB.last_name ?? '',
            ...(typedProfile.preferred_name && { preferred_name: typedProfile.preferred_name }),
            ...(dataWithUpdatedDOB.gender && { gender: dataWithUpdatedDOB.gender }),
            ...(dataWithUpdatedDOB.date_of_birth && { date_of_birth: dataWithUpdatedDOB.date_of_birth }),
            ...(dataWithUpdatedDOB.pronouns && { pronouns: dataWithUpdatedDOB.pronouns }),
            ...(dataWithUpdatedDOB.gender_identity && { gender_identity: dataWithUpdatedDOB.gender_identity }),
            ...(typedProfile.language.length > 0 && {
              languages: typedProfile.language.map((language) => language.id),
            }),
          };
          await createBasicInformation(basicInfoPayload as BasicInfo, newUser.id);
        }

        const formData = profileData as FormValues;
        const insuranceArray: Insurance[] = [];

        const hasPrimaryInsurance = addPrimaryInsurance && Number(formData.insurance_carrier_id) > 0;
        const hasSecondaryInsurance = addSecondaryInsurance && Number(formData.secondary_insurance_carrier_id) > 0;

        if (hasPrimaryInsurance) {
          let frontIds: string[] = [];
          let backIds: string[] = [];
          await Promise.all([
            (frontIds = await uploadMedia(formData.front_of_card)),
            (backIds = await uploadMedia(formData.back_of_card)),
          ]);

          const primary = updateDataInsuranceNewDesign(formData as any) as Insurance;
          primary.front_of_card = mapMediaToInsuranceMedia(frontIds, 'front_of_card');
          primary.back_of_card = mapMediaToInsuranceMedia(backIds, 'back_of_card');
          insuranceArray.push(primary);
        }

        if (hasSecondaryInsurance) {
          let sFrontIds: string[] = [];
          let sBackIds: string[] = [];
          await Promise.all([
            (sFrontIds = await uploadMedia(formData.secondary_front_of_card)),
            (sBackIds = await uploadMedia(formData.secondary_back_of_card)),
          ]);

          const secondary = updateDataSecondaryInsuranceNewDesign(formData as any) as Insurance;
          secondary.front_of_card = mapMediaToInsuranceMedia(sFrontIds, 'front_of_card');
          secondary.back_of_card = mapMediaToInsuranceMedia(sBackIds, 'back_of_card');
          secondary.is_secondary = true;
          insuranceArray.push(secondary);
        }

        if (insuranceArray.length > 0) {
          await createPatientInsurance({
            user_id: newUser.id,
            insurance: insuranceArray,
          });
        }
        setIsSavingProfile(false);
        toast.success('Patient created.', { className: 'fs-unmask' });
        onClose();
      } catch (error: unknown) {
        displayErrorDetails(error);
        setIsSavingProfile(false);
      }
    }
  };

  const updateCurrentAddress = (standardizedAddress: any, postalAddress: any, addressComponents: any): void => {
    const streetNumber = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'street_number',
    );
    const address1 = addressComponents.find((addressComponent: any) => addressComponent.componentType === 'route');
    const state = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'administrative_area_level_1',
    );

    if (postalAddress) {
      setValue('city', postalAddress.locality);
      setValue('zip_code', postalAddress.postalCode);
    }

    if (streetNumber || address1) {
      setValue('address1', `${streetNumber?.componentName?.text || ''} ${address1?.componentName?.text || ''}`.trim());
    }

    if (state) {
      setValue('state', state.componentName?.text || '');
    } else if (standardizedAddress?.state) {
      setValue('state', standardizedAddress.state);
    }
  };

  const onSubmitProfile = async (profileData: MyProfileSubmit): Promise<void> => {
    if (
      profileData.address1 !== '' ||
      profileData.address2 !== '' ||
      profileData.city !== '' ||
      profileData.state !== '' ||
      profileData.zip_code !== ''
    ) {
      await validateAddress(
        profileData,
        getValues as UseFormGetValues<UnifiedProfileSubmit>,
        validationResponseId,
        callSaveProfile,
        setValidationResponseId,
        setShowValidationAddressModal,
        onCloseConfirmationModal,
        updateCurrentAddress,
      );
    } else callSaveProfile(profileData);
  };

  const onChange = (key: keyof MyProfileSubmit, value: string | number): void => {
    setValue(key as keyof FormValues, value, { shouldValidate: true });
  };

  const uploadMedia = async (imagesValue: UploadedFile[] | undefined | null): Promise<string[]> => {
    if (!Array.isArray(imagesValue)) return [];

    const newUploadedImages = imagesValue.filter((img) => (img as any)?.dataURL?.startsWith('data:'));
    const existingImages = imagesValue.filter((img) => (img as any)?.dataURL?.startsWith('https://'));

    const base64List = newUploadedImages.map((img) => (img as any).dataURL as string);
    const fileList = await base64ListToFileList(base64List || []);
    const mediaIDs: string[] = [];

    if (newUploadedImages.length > 0 && Array.isArray(fileList)) {
      await Promise.all(
        Array.from(fileList).map(async (file, index) => {
          const img = newUploadedImages[index] as any;
          const mimeType = getFileMimeType(img.name);
          const payload = { files: [{ filename: img.name, mimetype: mimeType }] };
          const registered = await registerOneReportMedia(payload, userInfo.role.name);
          const mediaId = registered.files[0].upload_id;
          await fetch(registered.files[0].upload_url, {
            method: 'PUT',
            body: file,
            headers: { 'content-type': mimeType },
          });
          await confirmOneReportMedia(mediaId, userInfo.role.name);
          mediaIDs.push(mediaId);
        }),
      );
    }

    if (existingImages.length > 0) {
      const existingIds = existingImages.map((img: any) => img.media_id).filter(Boolean) as string[];
      mediaIDs.push(...existingIds);
    }

    return mediaIDs;
  };

  const mapMediaToInsuranceMedia = (media: string[], type: string): { media_id: string; type: string }[] => {
    return media.map((mediaId) => ({ media_id: mediaId, type }));
  };

  const addImages = (files: File[], type: keyof typeof images): void => {
    const newImages = files.filter(
      (file) =>
        file.type.startsWith('image/') ||
        file.type === 'application/pdf' ||
        file.type === 'application/msword' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/vnd.ms-powerpoint' ||
        file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    );

    if (((watch(type as any) as any[]) || []).length + newImages.length > 10) {
      displayErrorDetails('Max 10 files are allowed to upload.');
      return;
    }

    const imagesArray: UploadedFile[] = [];
    for (let i = 0; i < newImages.length; i++) {
      const file = newImages[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', () => {
        imagesArray.push({ name: file.name, dataURL: reader.result as string });
        if (imagesArray.length === newImages.length) {
          setValue(type as any, imagesArray as any, { shouldValidate: true });
          setImages((prev: any) => ({ ...prev, [type]: imagesArray }));
        }
      });
    }
  };

  const deleteMedia = (mediaName: string, type: keyof typeof images): void => {
    const current = ((watch(type as any) as any[]) || []).filter((img) => img.name !== mediaName);
    setValue(type as any, current as any, { shouldValidate: true });
    setImages((prev: any) => ({ ...prev, [type]: (prev[type] || []).filter((img: any) => img.name !== mediaName) }));
  };

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const files = Array.from(event.target.files as unknown as File[]);
    const converted = await Promise.all(
      files.map(async (file) => {
        if (file.type === 'image/heic') {
          const jpegBlob = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.85 });
          return new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), { type: 'image/jpeg' });
        }
        return file;
      }),
    );
    addImages(converted, event.target.id as any);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>, type: any): Promise<void> => {
    event.preventDefault();
    setIsDragging(false);
    if (!event.dataTransfer.files?.length) return;
    let file = event.dataTransfer.files[0];
    if (file.type === 'image/heic') {
      const jpegBlob = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.85 });
      file = new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), { type: 'image/jpeg' });
    }
    addImages([file], type);
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const onSecondaryInsuranceToggle = (_event: React.SyntheticEvent, expanded: boolean): void => {
    if (!expanded) {
      Object.keys(defaultInsuranceForm).forEach((k) => {
        if (String(k).startsWith('secondary_')) {
          setValue(k as any, (defaultInsuranceForm as any)[k], { shouldValidate: true });
        }
      });
      setImages((prev: any) => ({
        ...prev,
        secondary_front_of_card: [],
        secondary_back_of_card: [],
      }));
    }
    setAddSecondaryInsurance(expanded);
  };

  const onPrimaryInsuranceToggle = (_event: React.SyntheticEvent, expanded: boolean): void => {
    if (!expanded) {
      Object.keys(defaultInsuranceForm).forEach((k) => {
        if (!String(k).startsWith('secondary_')) {
          setValue(k as any, (defaultInsuranceForm as any)[k], { shouldValidate: true });
        }
      });
      setImages((prev: any) => ({
        ...prev,
        front_of_card: [],
        back_of_card: [],
      }));
      setAddSecondaryInsurance(false);
      Object.keys(defaultInsuranceForm).forEach((k) => {
        if (String(k).startsWith('secondary_')) {
          setValue(k as any, (defaultInsuranceForm as any)[k], { shouldValidate: true });
        }
      });
      setImages((prev: any) => ({
        ...prev,
        secondary_front_of_card: [],
        secondary_back_of_card: [],
      }));
    }
    setAddPrimaryInsurance(expanded);
  };

  useEffect(() => {
    if (Object.keys(myProfileForm).length > 0) {
      Object.keys(myProfileForm).forEach((key: unknown) => {
        setValue(key as keyof MyProfileSubmit, myProfileForm[key as keyof MyProfileSubmit]);
      });
    }
  }, [myProfileForm, setValue]);

  const formContent = (
    <>
      <div className={cn(styles.profileContainer, styles.newDesignProfileContainer, styles.providerPixelPerfect)}>
        <div className={styles.contentContainer}>
          <div className={styles.contentContainerInner}>
            <div className={styles.editProfileContainer}>
              <div className={styles.backButtonContainer}>
                <button type="button" className={styles.backButton} onClick={onClose}>
                  <ChevronLeftIcon className={styles.backButtonIcon} aria-hidden />
                  Back
                </button>
              </div>
              <Alert severity="info" className={styles.createUserNotice} style={{ marginBottom: '24px' }}>
                <AlertTitle>Creating patient profile</AlertTitle>
              </Alert>
              <div className={styles.providerInviteSection}>
                <div className={styles.providerInviteTitle}>Send invitation to user?</div>
                <ToggleButtonGroup
                  exclusive
                  size="small"
                  value={isSendingInvitation ? 'yes' : 'no'}
                  onChange={(_, value) => {
                    if (value !== null) {
                      setIsSendingInvitation(value === 'yes');
                    }
                  }}
                  className={styles.providerInviteToggle}
                >
                  <ToggleButton value="yes">Yes</ToggleButton>
                  <ToggleButton value="no">No</ToggleButton>
                </ToggleButtonGroup>
              </div>
              <div className={styles.separator} />
              <div className={styles.titleContainer}>
                <span className={styles.title}>Basic information</span>
              </div>
              <div className={styles.editContainer}>
                <form className={styles.formContainer} onSubmit={handleSubmit(onSubmitProfile, onInvalid)}>
                  <div className={styles.headerActionDiv}>
                    <ProfileImage
                      reviewProfile
                      setCurrentAvatarURL={setCurrentAvatarURL}
                      setAvatarFile={setAvatarFile}
                      setAvatarPayload={setAvatarPayload}
                      setAvatarAction={setAvatarAction}
                      triggerProfileAvatar={triggerProfileAvatar}
                      setImage={setImage}
                      image={image}
                      errors={errors}
                      size="80px"
                      isNewDependent
                    />
                  </div>

                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <TextField
                        {...register('first_name')}
                        label="First Name"
                        required={isQuickAdd || isSendingInvitation}
                        errors={errors}
                        name="first_name"
                        value={getValues('first_name')}
                        onChange={(e) => setTextValue(e, 'first_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <TextField
                        {...register('middle_name')}
                        label="Middle Name"
                        errors={errors}
                        name="middle_name"
                        value={getValues('middle_name')}
                        onChange={(e) => setTextValue(e, 'middle_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <TextField
                        {...register('last_name')}
                        label="Last Name"
                        required={isQuickAdd || isSendingInvitation}
                        errors={errors}
                        name="last_name"
                        value={getValues('last_name')}
                        onChange={(e) => setTextValue(e, 'last_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.details, styles.rowItemHalf)}>
                      <TextField
                        {...register('preferred_name')}
                        label="Preferred name (optional)"
                        errors={errors}
                        name="preferred_name"
                        value={getValues('preferred_name') || ''}
                        onChange={(e) => setTextValue(e, 'preferred_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details, styles.rowItemHalf)}>
                      <TextField
                        {...register('date_of_birth')}
                        errors={errors}
                        name="date_of_birth"
                        label="Date of birth"
                        required={isQuickAdd}
                        value={getValues('date_of_birth')}
                        onChange={(e) => dateAutoSlashes(e, 'date_of_birth', setValue)}
                        maxLength={10}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <MUISelectInput
                        {...register('gender')}
                        name="gender"
                        label="Gender assigned at birth"
                        options={genderOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={getValues('gender') || ''}
                        onChange={(value: string) => {
                          setValue('gender', value, { shouldValidate: true });
                        }}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <MUISelectInput
                        {...register('gender_identity')}
                        name="gender_identity"
                        label="Gender identity"
                        options={genderIdentity}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={getValues('gender_identity') || ''}
                        onChange={(value: string) => {
                          if (value) {
                            setValue('gender_identity', value, { shouldValidate: true });
                          }
                        }}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <MUISelectInput
                        {...register('pronouns')}
                        name="pronouns"
                        label="Pronouns (optional)"
                        options={pronounsOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={getValues('pronouns') || ''}
                        onChange={(value: string) => {
                          if (value) {
                            setValue('pronouns', value, { shouldValidate: true });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.details, styles.rowItemHalf, styles.languages)}>
                      <MultiSelectInputMUI
                        {...register('language')}
                        name="language"
                        label="Languages"
                        withId
                        options={languageOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={(getValues('language') || []).map((language) => String(language.id))}
                        onChange={(ids: string[]) => {
                          const selected = languageOptions.filter((option) => ids.includes(String(option.id)));
                          setValue('language', selected, {
                            shouldValidate: true,
                          });
                        }}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details, styles.rowItemHalf)}>
                      <div className={styles.inputWrapper}>
                        <PhoneInput
                          {...register('phone_number')}
                          label="Phone number"
                          id="phone_number"
                          value={getValues('phone_number') as E164Number}
                          onChange={(val) => {
                            setValue('phone_number', val as string, {
                              shouldValidate: true,
                            });
                          }}
                          inputClass={styles.input}
                          errors={errors}
                          wrapperClassName={styles.inputWrapper}
                        />
                      </div>
                    </div>
                  </div>
                  <AddressSection
                    register={register}
                    errors={errors}
                    getValues={getValues}
                    setTextValue={setTextValue}
                    setValue={setValue}
                    showValidationAddressModal={showValidationAddressModal}
                    required={false}
                  />
                  <div className={cn(styles.row, styles.patientEmailRow)}>
                    <div className={cn(styles.rowItem, styles.details, styles.big)}>
                      <TextField
                        {...register('email')}
                        label="Email Address"
                        required={!isQuickAdd}
                        errors={errors}
                        name="email"
                        value={getValues('email')}
                        onChange={(e) => {
                          setTextValue(e, 'email');
                          setEmail(e.target.value);
                        }}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <div className={styles.separator} />
                  <div className={styles.editProfileContainer}>
                    <div className={styles.editContainer}>
                      {Array.isArray(watch('organization')) &&
                        watch('organization').some((org) => org.id === 'dentistry-one') &&
                        clientTagOptions.length > 0 && (
                          <>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '20px', mb: 2 }}>
                              Client tags
                            </Typography>
                            <p className={addNewUserStyles.clientTagsDescription}>
                              Select the client tag for this patient&apos;s Dentistry.One services.
                            </p>
                            <div className={addNewUserStyles.inputWrap}>
                              <MUISelectInput
                                name="clientTag"
                                label="Client tag"
                                required={clientTagsRequired}
                                value={watch('clientTag')?.[0]?.value ?? ''}
                                options={clientTagOptions}
                                onChange={(value: string) => {
                                  const selected = clientTagOptions.find((tag) => tag.value === value);
                                  setValue('clientTag', selected ? [selected] : [], { shouldValidate: true });
                                  setValue('clientDivision', [], { shouldValidate: true });
                                }}
                              />
                            </div>
                            {(watch('clientTag') || []).length > 0 && divisionOptions.length > 0 && (
                              <div className={addNewUserStyles.inputWrap}>
                                <MUISelectInput
                                  name="clientDivision"
                                  label="Division"
                                  value={watch('clientDivision')?.[0]?.value ?? ''}
                                  options={divisionOptions}
                                  onChange={(value: string) => {
                                    const selected = divisionOptions.find((division) => division.value === value);
                                    setValue('clientDivision', selected ? [selected] : [], { shouldValidate: true });
                                  }}
                                />
                              </div>
                            )}
                          </>
                        )}
                      {Array.isArray(watch('organization')) &&
                        watch('organization').some((org) => org.id === 'dentistry-one') &&
                        (watch('clientTag') || []).length === 1 && (
                          <>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '20px', mb: 2 }}>
                              User IDs
                            </Typography>
                            <div className={addNewUserStyles.inputWrap}>
                              <TextField
                                {...register('external_id')}
                                label="External User ID"
                                errors={errors}
                                name="external_id"
                                value={getValues('external_id') || ''}
                                onChange={(e) => setTextValue(e, 'external_id')}
                                maxLength={40}
                                wrapperClassName={styles.inputWrapper}
                                inputClass={styles.input}
                              />
                            </div>
                          </>
                        )}
                    </div>
                  </div>

                  <Divider sx={{ my: 3 }} />

                  <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '20px' }}>
                    Insurance information
                  </Typography>

                  <Divider sx={{ my: 2 }} />

                  <Box>
                    <Accordion
                      expanded={addPrimaryInsurance}
                      onChange={onPrimaryInsuranceToggle}
                      className={addNewUserStyles.insuranceAccordion}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon className={addNewUserStyles.insuranceAccordionExpandIcon} />}
                        className={addNewUserStyles.insuranceAccordionSummary}
                      >
                        <Typography className={addNewUserStyles.insuranceAccordionTitle}>
                          Primary insurance information
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className={addNewUserStyles.insuranceAccordionDetails}>
                        <InsuranceFormSection
                          hideTitle
                          isSecondary={false}
                          allowNoInsuranceCarrier
                          phoneInputRef={phoneInputRef}
                          register={register as any}
                          errors={errors as any}
                          setValue={setValue as any}
                          watch={watch as any}
                          getValues={getValues as any}
                          handleChange={handleChange}
                          handleDragOver={handleDragOver}
                          handleDrop={handleDrop}
                          handleDragEnter={handleDragEnter}
                          handleDragLeave={handleDragLeave}
                          isDragging={isDragging}
                          deleteMedia={deleteMedia}
                          images={images as any}
                          profileAddressSource={{
                            address1: watch('address1') || '',
                            address2: watch('address2') || '',
                            city: watch('city') || '',
                            state: watch('state') || '',
                            zip_code: watch('zip_code') || '',
                          }}
                        />
                      </AccordionDetails>
                    </Accordion>

                    {addPrimaryInsurance && (
                      <Accordion
                        expanded={addSecondaryInsurance}
                        onChange={onSecondaryInsuranceToggle}
                        className={addNewUserStyles.insuranceAccordion}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon className={addNewUserStyles.insuranceAccordionExpandIcon} />}
                          className={addNewUserStyles.insuranceAccordionSummary}
                        >
                          <Typography className={addNewUserStyles.insuranceAccordionTitle}>
                            Secondary insurance information
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={addNewUserStyles.insuranceAccordionDetails}>
                          <InsuranceFormSection
                            hideTitle
                            isSecondary
                            allowNoInsuranceCarrier
                            phoneInputRef={phoneInputRef}
                            register={register as any}
                            errors={errors as any}
                            setValue={setValue as any}
                            watch={watch as any}
                            getValues={getValues as any}
                            handleChange={handleChange}
                            handleDragOver={handleDragOver}
                            handleDrop={handleDrop}
                            handleDragEnter={handleDragEnter}
                            handleDragLeave={handleDragLeave}
                            isDragging={isDragging}
                            deleteMedia={deleteMedia}
                            images={images as any}
                            profileAddressSource={{
                              address1: watch('address1') || '',
                              address2: watch('address2') || '',
                              city: watch('city') || '',
                              state: watch('state') || '',
                              zip_code: watch('zip_code') || '',
                            }}
                          />
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </Box>

                  <div className={styles.providerActionBtnContainer}>
                    <Button type="submit" className={styles.providerSubmit} disabled={isSavingProfile}>
                      Save changes
                    </Button>
                    <Button type="button" className={styles.providerCancel} onClick={onCancelEditProfile}>
                      Cancel
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  /* Parent AddUserPage already provides Container + #patientDashboardPosition; avoid nested scroll layers. */
  return <>{formContent}</>;
};
export default AddPatientUserPage;
